/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddPaymentbycardRequest as AgentApiContractAddPaymentbycardRequest } from '../../models/AgentApi/Contract/add-paymentbycard-request';
import { AddPaymentbycardResponse as AgentApiContractAddPaymentbycardResponse } from '../../models/AgentApi/Contract/add-paymentbycard-response';

export interface ApiAgentAddPaymentbycardPost$Params {

/**
 * Interface language
 */
  lang?: string;
      body?: AgentApiContractAddPaymentbycardRequest
}

export function apiAgentAddPaymentbycardPost(http: HttpClient, rootUrl: string, params?: ApiAgentAddPaymentbycardPost$Params, context?: HttpContext): Observable<StrictHttpResponse<AgentApiContractAddPaymentbycardResponse>> {
  const rb = new RequestBuilder(rootUrl, apiAgentAddPaymentbycardPost.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AgentApiContractAddPaymentbycardResponse>;
    })
  );
}

apiAgentAddPaymentbycardPost.PATH = '/api/Agent/AddPaymentbycard';
